<div class="card-wrapper">
  <div >
    <div>
      <img class="jackpot-icon" src="{{ data?.trigger?.jackpot_image }}" alt="jackpot-icon" />
    </div>
    @if (!data?.status) {
      <ion-card
      [ngClass]="
        data?.trigger?.jackpot_name === 'EuroMillions'
          ? 'blue-bg'
          : data?.trigger?.jackpot_name === 'Lotto'
          ? 'lotto_bg'
          : 'powerball_bg'
      "
        >
        <ion-card-header>
          <h4>{{ "jackpot-warning.sure" | translate }}</h4>
        </ion-card-header>
        <ion-card-content>
          <div>
            <p>{{ "jackpot-warning.aboutToTurn" | translate }} <br />{{ "jackpot-warning.jackpotTrigger" | translate }}</p>
            <p>{{ "jackpot-warning.threshhold" | translate }}</p>
          </div>
          <ion-button
            (click)="turnOff()"
            class="purple-btn"
            [disabled]="isDeactivating"
          >{{ "jackpot-warning.turnOff" | translate }}</ion-button>
          <p
            class="sub-link"
            [class.disabled]="isDeactivating"
            [attr.aria-disabled]="isDeactivating"
            (click)="!isDeactivating && close()"
          >{{ "jackpot-warning.mind" | translate }}</p>
        </ion-card-content>
      </ion-card>
    }
  </div>
</div>